import axios from "axios";

export async function getVehicleData(vin, values) {
  var year;
  var type;
  var model;
  var make;
  var class_value;

  await axios
    .get(
      `https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/${vin}?format=json`
    )
    .then((r) => {
      for (let i = 0; i < r.data.Results.length; i++) {
        if (r.data.Results[i].Variable === 'Model Year') {
          year = r.data.Results[i].Value;
        }
      }

      for (let i = 0; i < r.data.Results.length; i++) {
        if (r.data.Results[i].Variable === 'Make') {
          make = r.data.Results[i].Value;
        }
      }

      for (let i = 0; i < r.data.Results.length; i++) {
        if (r.data.Results[i].Variable === 'Model') {
          model = r.data.Results[i].Value;
        }
      }

      for (let i = 0; i < r.data.Results.length; i++) {
        if (r.data.Results[i].Variable === 'Vehicle Type') {
          type = r.data.Results[i].Value;
        }
      }

      const results = Array.isArray(r?.data?.Results) ? r.data.Results : [];

      const parseClassToken = (s) => {
        if (typeof s !== "string") return null;
        // Match: "Class 2H:", "Class 2A", "Class 8", etc.
        const m = s.match(/^Class\s+([0-9]+[A-Za-z]?)/i);
        if (!m) return null;
        let token = m[1].toLowerCase(); // e.g., "2h", "2a", "8"

        // Map 2h -> 2b
        if (token === "2h" || token === "2g") token = "2b";

        return token;
      };

      for (const row of results) {
        // Prefer the Variable field (per your examples), then fallback to Value
        const token =
          parseClassToken(row?.Variable) ??
          parseClassToken(row?.Value);

        if (token) {
          class_value = token; // e.g., "2a", "2b", "8"
          break;
        }
      }

    })
    .catch((error) => {
      console.error(error);
    });

  return {
    type,
    year:
      year !== null
        ? year
        : values.year
        ? values.year
        : '',
    model:
      model !== null
        ? model
        : values.model
        ? values.model
        : '',
    make:
      make !== null
        ? make
        : values.make
        ? values.make
        : '',
    class_value:
      class_value !== null
        ? class_value
        : values.class
        ? values.class
        : '',
  };
}
